module.exports = __webpack_public_path__ + "static/risa-771446a296d25289127453bb9511e103.webp";